import builder from '../builder';
import CakeBirthday from '../../streamline-icons/light/cake-birthday.svg';

export default builder('IconCakeBirthdayLight', CakeBirthday);
